"use strict";

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var DOMException = require("domexception/webidl2js-wrapper");

var NODE_TYPE = require("../node-type");

var AbstractRangeImpl = require("./AbstractRange-impl").implementation; // https://dom.spec.whatwg.org/#staticrange


var StaticRangeImpl =
/*#__PURE__*/
function (_AbstractRangeImpl) {
  _inherits(StaticRangeImpl, _AbstractRangeImpl);

  // https://dom.spec.whatwg.org/#dom-staticrange-staticrange
  function StaticRangeImpl(globalObject, args) {
    _classCallCheck(this, StaticRangeImpl);

    var _args$ = args[0],
        startContainer = _args$.startContainer,
        startOffset = _args$.startOffset,
        endContainer = _args$.endContainer,
        endOffset = _args$.endOffset;

    if (startContainer.nodeType === NODE_TYPE.DOCUMENT_TYPE_NODE || startContainer.nodeType === NODE_TYPE.ATTRIBUTE_NODE || endContainer.nodeType === NODE_TYPE.DOCUMENT_TYPE_NODE || endContainer.nodeType === NODE_TYPE.ATTRIBUTE_NODE) {
      throw DOMException.create(globalObject, ["The supplied node is incorrect.", "InvalidNodeTypeError"]);
    }

    return _possibleConstructorReturn(this, _getPrototypeOf(StaticRangeImpl).call(this, globalObject, [], {
      start: {
        node: startContainer,
        offset: startOffset
      },
      end: {
        node: endContainer,
        offset: endOffset
      }
    }));
  }

  return StaticRangeImpl;
}(AbstractRangeImpl);

module.exports = {
  implementation: StaticRangeImpl
};